export default "./dist/stdassets/images/icons/control.png";